/* Different Drips — localStorage wishlist: card hearts + header drawer */
(function () {
  var KEY = 'dd_wishlist_v1';

  function read() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }
  function write(items) {
    localStorage.setItem(KEY, JSON.stringify(items));
    refresh();
  }
  function has(handle) {
    return read().some(function (i) {
      return i.handle === handle;
    });
  }

  function refresh() {
    var items = read();
    var saved = {};
    for (var k = 0; k < items.length; k++) saved[items[k].handle] = true;
    /* header count */
    document.querySelectorAll('.dd-wish-count').forEach(function (el) {
      el.textContent = items.length;
      el.hidden = items.length === 0;
    });
    /* card hearts */
    document.querySelectorAll('.dd-wish[data-handle]').forEach(function (btn) {
      var isSaved = saved[btn.dataset.handle] === true;
      btn.classList.toggle('is-saved', isSaved);
      btn.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
    });
    renderDrawer(items);
  }

  function renderDrawer(items) {
    var list = document.querySelector('.dd-wishlist-drawer__items');
    var empty = document.querySelector('.dd-wishlist-drawer__empty');
    if (!list) return;
    if (!items.length) {
      list.dataset.sig = '';
      list.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    var sig = items.map(function (i) { return i.handle; }).join(',');
    if (list.dataset.sig === sig) return;
    list.dataset.sig = sig;
    list.innerHTML = items
      .map(function (i) {
        return (
          '<div class="dd-wishlist-item">' +
          '<a href="' + i.url + '"><img src="' + i.image + '" alt="" loading="lazy" width="72" height="72"></a>' +
          '<div class="dd-wishlist-item__info">' +
          '<a class="dd-wishlist-item__title" href="' + i.url + '">' + i.title + '</a>' +
          '<span class="dd-wishlist-item__price">' + (i.price || '').replace(/\.00(?=\D*$)/, '') + '</span>' +
          '</div>' +
          '<button type="button" class="dd-wishlist-item__remove" data-remove="' + i.handle + '" aria-label="Remove">&times;</button>' +
          '</div>'
        );
      })
      .join('');
  }

  function openDrawer() {
    var d = document.querySelector('.dd-wishlist-drawer');
    if (!d) return;
    d.hidden = false;
    requestAnimationFrame(function () {
      d.classList.add('is-open');
    });
    document.body.classList.add('dd-wishlist-open');
  }
  function closeDrawer() {
    var d = document.querySelector('.dd-wishlist-drawer');
    if (!d) return;
    d.classList.remove('is-open');
    document.body.classList.remove('dd-wishlist-open');
    setTimeout(function () {
      d.hidden = true;
    }, 250);
  }

  document.addEventListener(
    'click',
    function (e) {
      var heart = e.target.closest('.dd-wish[data-handle]');
      if (heart) {
        e.preventDefault();
        e.stopPropagation();
        var items = read();
        if (has(heart.dataset.handle)) {
          items = items.filter(function (i) {
            return i.handle !== heart.dataset.handle;
          });
        } else {
          items.push({
            handle: heart.dataset.handle,
            url: heart.dataset.url,
            title: heart.dataset.title,
            image: heart.dataset.image,
            price: heart.dataset.price,
          });
        }
        write(items);
        return;
      }

      var toggle = e.target.closest('.dd-wish-toggle');
      if (toggle) {
        e.preventDefault();
        openDrawer();
        return;
      }

      var remove = e.target.closest('[data-remove]');
      if (remove) {
        e.preventDefault();
        write(
          read().filter(function (i) {
            return i.handle !== remove.dataset.remove;
          })
        );
        return;
      }

      if (e.target.closest('.dd-wishlist-drawer__close') || e.target.classList.contains('dd-wishlist-drawer__overlay')) {
        e.preventDefault();
        closeDrawer();
      }
    },
    true
  );

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* keep hearts in sync as sections (recommendations, quick-add) inject cards */
  var WATCH = '.dd-wish, .dd-wish-count, .dd-wishlist-drawer__items';
  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && (n.matches(WATCH) || n.querySelector(WATCH))) {
          clearTimeout(mo._t);
          mo._t = setTimeout(refresh, 200);
          return;
        }
      }
    }
  });

  function init() {
    /* sticky-header animates transform, which traps fixed children — reparent drawer to body */
    var drawer = document.querySelector('.dd-wishlist-drawer');
    if (drawer && drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }
    refresh();
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
